import React, { useEffect, useState } from "react";
import MainCard from "../../components/ui-component/card/MainCard";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { DataGrid } from "@mui/x-data-grid";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import { useGetTokenOrLogout } from "../../../utils/token";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function TakeAttendance() {
  const userId = localStorage.getItem("userId");
  const [isFilterOpen, setFilterOpen] = useState(true);
  const [selectedClass, setSelectedClass] = useState("");
  const [trainerName, setTrainerName] = useState("");
  const [deliveryMode, setDeliveryMode] = useState("");
  const [branch, setBranch] = useState("");
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(getTodayDate());
  const [trainers, setTrainers] = useState([]);
  const [selectedTrainer, setSelectedTrainer] = useState("");
  const [classes, setClasses] = useState([]);
  const [attendanceStatus, setAttendanceStatus] = useState({});

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [countryCode, setCountryCode] = useState("+91");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(null);
  const [otpWillExpire, setOtpWillExpire] = useState(null);
  const [otpMessage, setOtpMessage] = useState("");
  const [isOtpFetched, setIsOtpFetched] = useState(false);
  const [CountryList, setCountryList] = useState([]);
  const [isdCode, setIsdCode] = useState("91");
  const [errors, setErrors] = useState({});
  const [inputType, setInputType] = useState("phone");
  const [email, setEmail] = useState("");

  const getTokenOrLogout = useGetTokenOrLogout();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const toggleFilterSection = () => {
    setFilterOpen(!isFilterOpen);
  };

  function getTodayDate() {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  const fetchTrainers = async () => {
    try {
      const response = await fetch(
        `${API_ENDPOINT}route/getalltrainer/${userId}`,
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching trainers:", error);
      throw error;
    }
  };

  useEffect(() => {
    // Fetch trainers when the component mounts
    fetchTrainers()
      .then((trainerData) => {
        setTrainers(trainerData);
      })
      .catch((error) => {
        console.error("Error fetching trainers:", error);
      });
  }, []);

  const handleTrainerChange = (event) => {
    const selectedTrainerId = event.target.value;

    // Find the selected trainer from the trainers data
    const selectedTrainer = trainers.find(
      (trainer) => trainer.id === selectedTrainerId,
    );

    // Update the state with the selected trainer's classes
    setClasses(selectedTrainer ? selectedTrainer.classes : []);

    // If there are classes, prefill delivery mode and branch with the first class data
    if (selectedTrainer && selectedTrainer.classes.length > 0) {
      setDeliveryMode(selectedTrainer.classes[0].delivery_mode);
      setBranch(selectedTrainer.branch_id?.branch_name || ""); // Assuming branch_name is the property you want for the branch
    } else {
      // Reset delivery mode and branch if no classes are available
      setDeliveryMode("");
      setBranch("");
    }

    // Reset selected class
    setSelectedClass("");
    setSelectedTrainer(selectedTrainerId);
  };

  const fetchClassesFromAPI = async (date, trainerId, classId) => {
    try {
      setLoading(true);
      const response = await fetch(`${API_ENDPOINT}route/markattendancelist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          date,
          trainer_id: trainerId,
          class_id: classId,
          user_id: userId,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setLoading(false);
        setStudents(data);
      } else if (response.status === 400) {
        showSnackbar(data.message, "error");
        setLoading(false);
        setStudents([]);
      } else {
        setLoading(false);
        setStudents([]);
        showSnackbar("Error feching student Data", "error");
      }
    } catch (error) {
      setLoading(false);
      setStudents([]);
      console.error("Error fetching classes:", error);
      showSnackbar("Error feching student Data", "error");
    }
  };

  useEffect(() => {
    // Fetch classes when the user selects a date, trainer, and class
    // if (selectedDate && selectedTrainer && selectedClass) {
    //   setLoading(true);
    //   fetchClassesFromAPI(selectedDate, selectedTrainer, selectedClass)
    //     .then((students) => {

    //       setLoading(false);
    //       setStudents(students);
    //       // Proceed with other logic, e.g., fetching and displaying students data
    //     })
    //     .catch((error) => {
    //       console.log('erroris',  error.message)
    //       if (error.message.includes("401")) {
    //         showSnackbar("Unauthorized to fetch students", "error");
    //         setLoading(false);
    //         setStudents([]);
    //       } else if (error.message.includes("403")) {
    //         showSnackbar("No Students in this class on this day", "error");
    //         setLoading(false);
    //         setStudents([]);
    //       } else if (error.message.includes("400")) {
    //         showSnackbar("Can not take attendance on Sunday", "error");
    //         setLoading(false);
    //         setStudents([]);
    //       } else {
    //         console.error("Error fetching student data:", error);
    //         showSnackbar("Error fetching enquiries data:", "error");
    //         setLoading(false);
    //         setStudents([]);
    //       }
    //     });
    // }

    if (selectedDate && selectedTrainer && selectedClass) {
      fetchClassesFromAPI(selectedDate, selectedTrainer, selectedClass);
    }
  }, [selectedDate, trainerName, selectedClass]);

  const columns = [
    {
      field: "action",
      headerClassName: "header-cell",
      headerName: "Mark Attendance",
      flex: 2,
      minWidth: 350,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          {attendanceStatus[params.row.id] || params?.row.is_mark ? (
            <Chip
              size="small"
              variant="contained"
              color="secondary"
              label="Attendance Marked"
            />
          ) : (
            <>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={() =>
                  handleMarkAttendance(
                    params.row.student_id.id,
                    "1",
                    params.row.id,
                    params?.row?.student_id?.sp_user_id,
                  )
                }
                disabled={params.row.attendanceStatus === "Present"}
              >
                Present
              </Button>
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() =>
                  handleMarkAttendance(
                    params.row.student_id.id,
                    "0",
                    params.row.id,
                  )
                }
                disabled={params.row.attendanceStatus === "Absent"}
              >
                Absent
              </Button>
              <Button
                variant="contained"
                color="warning"
                size="small"
                onClick={() =>
                  handleMarkAttendance(
                    params.row.student_id.id,
                    "-1",
                    params.row.id,
                  )
                }
                disabled={params.row.attendanceStatus === "Absent"}
              >
                Absent with permission
              </Button>
            </>
          )}
        </Box>
      ),
    },
    {
      field: "lead_no",
      headerName: "Enroll ID",
      flex: 0.5,
      minWidth: 100,
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params.row?.student_id?.lead_no}</div>,
    },
    {
      field: "studentName",
      headerClassName: "header-cell",
      headerName: "Student Name",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      minWidth: 150,
      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.first_name}{" "}
          {params.row?.enquiry_id?.last_name}
        </div>
      ),
    },
    {
      field: "leave_request",
      headerClassName: "header-cell",
      headerName: "Leave Request",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      minWidth: 100,
      renderCell: (params) => (
        <div>{params.row?.is_leave === true ? "Yes" : "No"}</div>
      ),
    },

    {
      field: "enr_date",
      headerClassName: "header-cell",
      headerName: "Enrollment Date",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      minWidth: 100,
      renderCell: (params) => <div>{params.row?.enrollment_date}</div>,
    },

    {
      field: "class_name",
      headerClassName: "header-cell",
      headerName: "Class",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <div>{params.row?.class_id?.name}</div>,
    },
    {
      field: "package",
      headerClassName: "header-cell",
      headerName: "Package",
      flex: 0.5,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <div>{params.row?.package_id?.package_name}</div>,
    },
  ];

  const handleMarkAttendance = async (
    studentId,
    attendanceStatus,
    studentClassDetailsId,
    sp_user_id,
  ) => {
    console.log("sp_user_id", sp_user_id);
    try {
      const response = await fetch(`${API_ENDPOINT}attendance`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          student_class_details_id: studentClassDetailsId,
          student_id: studentId,
          class_id: selectedClass,
          date: selectedDate,
          attendance_val: attendanceStatus,
          user_id: userId,
          sp_user_id: sp_user_id,
        }),
      });

      if (!response.ok) {
        showSnackbar("Error marking attendance", "error");
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setAttendanceStatus((prevStatus) => ({
        ...prevStatus,
        [studentClassDetailsId]: true,
      }));

      // You can add additional logic here after successfully marking attendance
    } catch (error) {
      if (error.message.includes("400")) {
        showSnackbar("Cannot mark attendance for future date", "error");
      } else if (error.message.includes("405")) {
        showSnackbar("Cannot mark attendance for Sunday", "error");
      } else {
        console.error("Error marking attendance:", error);
        showSnackbar("Error marking attendance", "error");
      }

      // Handle error if needed
    }
  };

  const renderContent = () => {
    if (loading) {
      return <LoaderComp isLoading={loading} />;
    }

    if (students.length === 0) {
      return (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          height="300px"
        >
          <Typography variant="h4">
            No students data. Select class and date.
          </Typography>
        </Grid>
      );
    }

    return (
      <Grid item xs={12}>
        <MainCard>
          <DataGrid
            rows={students}
            columns={columns}
            autoHeight
            pageSize={10}
            noRowsOverlay={
              <Typography variant="h6" color="textSecondary">
                No students available for the selected criteria.
              </Typography>
            }
          />
        </MainCard>
      </Grid>
    );
  };

  // ============================================
  // FETCH OTP
  // ============================================
  const fetchOtp = async () => {
    try {
      // Reset previous OTP state
      setOtp(null);
      setOtpWillExpire(null);
      setOtpMessage("");
      setIsOtpFetched(false);

      const token = getTokenOrLogout();
      if (!token) return;
      let headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", // Make sure to keep the content type
      };

      // ============================================
      // EMAIL VALIDATION
      // ============================================
      if (inputType === "email") {
        const value = email.trim();

        if (!value) {
          setOtpMessage("Please enter email address");
          setIsOtpFetched(true);
          return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (!emailRegex.test(value)) {
          setOtpMessage("Please enter a valid email address");
          setIsOtpFetched(true);
          return;
        }

        setErrors({});

        const payload = {
          user_id: userId,
          email: value,
        };

        console.log("OTP Payload:", payload);

        const response = await fetch(`${API_ENDPOINT}route/get-student-otp`, {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        console.log("OTP Response:", data);

        setIsOtpFetched(true);

        if (data?.success) {
          setOtp(data?.data?.otp);
          setOtpWillExpire(data?.data?.otp_will_expire);
          setOtpMessage("");
        } else {
          setOtp(null);
          setOtpWillExpire(null);
          setOtpMessage(data?.message || "OTP not found");
        }

        return;
      }

      // ============================================
      // PHONE VALIDATION
      // ============================================
      const value = phone.trim();

      if (!value) {
        setErrors((prev) => ({
          ...prev,
          mobile: true,
        }));

        setOtpMessage("Please enter mobile number");
        setIsOtpFetched(true);
        return;
      }

      // Only numbers
      if (!/^\d+$/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          mobile: true,
        }));

        setOtpMessage("Mobile number can contain only numbers");
        setIsOtpFetched(true);
        return;
      }

      // ISD code required
      if (!isdCode) {
        setErrors((prev) => ({
          ...prev,
          isdCode: true,
        }));

        setOtpMessage("Please select ISD Code");
        setIsOtpFetched(true);
        return;
      }

      // ============================================
      // INDIA (+91) = EXACTLY 10 DIGITS
      // ============================================
      if (String(isdCode) === "91" && value.length !== 10) {
        setErrors((prev) => ({
          ...prev,
          mobile: true,
        }));

        setOtpMessage("Indian mobile number must be exactly 10 digits");
        setIsOtpFetched(true);
        return;
      }

      // Other countries - basic length validation
      if (String(isdCode) !== "91" && (value.length < 7 || value.length > 15)) {
        setErrors((prev) => ({
          ...prev,
          mobile: true,
        }));

        setOtpMessage("Please enter a valid mobile number");
        setIsOtpFetched(true);
        return;
      }

      setErrors((prev) => ({
        ...prev,
        isdCode: false,
        mobile: false,
      }));

      // ============================================
      // PHONE API PAYLOAD
      // ============================================
      const payload = {
        user_id: userId,
        phone: value,
        country_code: `+${isdCode}`,
      };

      console.log("OTP Payload:", payload);

      const response = await fetch(`${API_ENDPOINT}route/get-student-otp`, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      console.log("OTP Response:", data);

      setIsOtpFetched(true);

      if (data?.success) {
        setOtp(data?.data?.otp);
        setOtpWillExpire(data?.data?.otp_will_expire);
        setOtpMessage("");
      } else {
        setOtp(null);
        setOtpWillExpire(null);
        setOtpMessage(data?.message || "OTP not found");
      }
    } catch (err) {
      console.error("Error fetching OTP:", err);

      setIsOtpFetched(true);
      setOtp(null);
      setOtpWillExpire(null);
      setOtpMessage("Something went wrong");
    }
  };

  // ============================================
  // ISD CODE CHANGE
  // ============================================
  const handleChangeIsdCode = (e) => {
    const value = e.target.value;

    setIsdCode(String(value));
    setCountryCode(`+${value}`);

    setErrors((prev) => ({
      ...prev,
      isdCode: false,
    }));
  };

  // ============================================
  // FORMAT OTP EXPIRY
  // ============================================
  const formatExpiry = (timestamp) => {
    if (!timestamp) return "";

    return new Date(timestamp).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  // ============================================
  // FETCH COUNTRIES
  // ============================================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}country`);

        if (response.ok) {
          const data = await response.json();

          const sortedData = [...data].sort(
            (a, b) => a.phone_code - b.phone_code,
          );

          const uniqueArray = sortedData.filter(
            (obj, index, self) =>
              index === self.findIndex((t) => t.phone_code === obj.phone_code),
          );

          setCountryList(uniqueArray);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "stretch",
              justifyContent: "space-between",
              gap: 2,
              p: 1.75,
              border: "1px solid #e6e6e6",
              borderRadius: "14px",
              backgroundColor: "#fff",
              marginBottom: 1.5,
              boxShadow: "0 2px 10px rgba(15, 23, 42, 0.04)",
            }}
          >
            {/* LEFT SIDE */}
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
              }}
            >
              {/* HEADER + PHONE / EMAIL TOGGLE */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: { xs: "flex-start", sm: "center" },
                  justifyContent: "space-between",
                  gap: 2,
                  mb: 2,
                  flexWrap: "wrap",
                }}
              >
           

                {/* PHONE / EMAIL TOGGLE */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: "3px",
                    gap: "2px",
                    borderRadius: "10px",
                    backgroundColor: "#f1f4f3",
                    border: "1px solid #e4e9e6",
                    flexShrink: 0,
                  }}
                >
                  {/* PHONE */}
                  <Box
                    onClick={() => {
                      setInputType("phone");
                      setOtp(null);
                      setOtpMessage("");
                      setIsOtpFetched(false);
                      setErrors({});
                    }}
                    sx={{
                      minWidth: { xs: 80, sm: 90 },
                      height: 34,
                      px: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.75,
                      borderRadius: "8px",
                      cursor: "pointer",
                      userSelect: "none",
                      fontSize: "12px",
                      fontWeight: 600,
                      transition: "all 0.2s ease",
                      backgroundColor:
                        inputType === "phone" ? "#ffffff" : "transparent",
                      color: inputType === "phone" ? "#237A3B" : "#737B82",
                      boxShadow:
                        inputType === "phone"
                          ? "0 1px 4px rgba(0,0,0,0.08)"
                          : "none",
                      "&:hover": {
                        color: "#237A3B",
                      },
                    }}
                  >
                    <span
                      style={{
                        fontSize: "13px",
                        lineHeight: 1,
                      }}
                    >
                      ☎
                    </span>
                    Phone
                  </Box>

                  {/* EMAIL */}
                  <Box
                    onClick={() => {
                      setInputType("email");
                      setOtp(null);
                      setOtpMessage("");
                      setIsOtpFetched(false);
                      setErrors({});
                    }}
                    sx={{
                      minWidth: { xs: 80, sm: 90 },
                      height: 34,
                      px: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.75,
                      borderRadius: "8px",
                      cursor: "pointer",
                      userSelect: "none",
                      fontSize: "12px",
                      fontWeight: 600,
                      transition: "all 0.2s ease",
                      backgroundColor:
                        inputType === "email" ? "#ffffff" : "transparent",
                      color: inputType === "email" ? "#237A3B" : "#737B82",
                      boxShadow:
                        inputType === "email"
                          ? "0 1px 4px rgba(0,0,0,0.08)"
                          : "none",
                      "&:hover": {
                        color: "#237A3B",
                      },
                    }}
                  >
                    <span
                      style={{
                        fontSize: "13px",
                        lineHeight: 1,
                      }}
                    >
                      ✉
                    </span>
                    Email
                  </Box>
                </Box>
              </Box>

              {/* INPUT AREA */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                  width: "100%",
                }}
              >
                {/* ================= PHONE ================= */}
                {inputType === "phone" && (
                  <>
                    {/* ISD CODE */}
                    <Box
                      sx={{
                        width: {
                          xs: "105px",
                          sm: "150px",
                          md: "180px",
                        },
                        flexShrink: 0,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          mb: 0.6,
                          fontWeight: 600,
                          fontSize: "11px",
                          color: "#59636E",
                        }}
                      >
                        ISD Code
                        <span
                          style={{
                            color: "#e53935",
                            marginLeft: "3px",
                          }}
                        >
                          *
                        </span>
                      </Typography>

                      <CustomTextFieldComp
                        size="small"
                        select
                        name="isdCode"
                        value={isdCode || ""}
                        onChange={handleChangeIsdCode}
                        InputProps={{
                          style: {
                            borderRadius: "9px",
                            fontSize: "12px",
                            backgroundColor: "#fafbfb",
                          },
                        }}
                        fullWidth
                        SelectProps={{
                          displayEmpty: true,
                          MenuProps: {
                            sx: {
                              maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
                              width: 250,
                            },
                          },
                        }}
                        error={Boolean(errors.isdCode)}
                      >
                        {CountryList.filter(
                          (country) =>
                            country &&
                            country.phone_code !== null &&
                            country.phone_code !== undefined,
                        ).map((country) => (
                          <MenuItem
                            key={String(country.phone_code)}
                            value={String(country.phone_code)}
                            sx={{
                              fontSize: "12px",
                            }}
                          >
                            +{country.phone_code}
                          </MenuItem>
                        ))}
                      </CustomTextFieldComp>

                      {errors.isdCode && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{
                            display: "block",
                            mt: 0.25,
                            fontSize: "10px",
                          }}
                        >
                          ISD Code is required
                        </Typography>
                      )}
                    </Box>

                    {/* MOBILE NUMBER */}
                    <Box
                      sx={{
                        width: {
                          xs: "220px",
                          sm: "320px",
                          md: "400px",
                        },
                        maxWidth: "400px",
                        flexShrink: 0,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          mb: 0.6,
                          fontWeight: 600,
                          fontSize: "11px",
                          color: "#59636E",
                        }}
                      >
                        Mobile Number
                        <span
                          style={{
                            color: "#e53935",
                            marginLeft: "3px",
                          }}
                        >
                          *
                        </span>
                      </Typography>

                      <CustomTextFieldComp
                        size="small"
                        type="tel"
                        placeholder={
                          String(isdCode) === "91"
                            ? "Enter 10 digit mobile number"
                            : "Enter mobile number"
                        }
                        InputProps={{
                          style: {
                            borderRadius: "9px",
                            fontSize: "12px",
                            backgroundColor: "#fafbfb",
                          },
                        }}
                        value={phone}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");

                          if (String(isdCode) === "91") {
                            setPhone(value.slice(0, 10));
                          } else {
                            setPhone(value.slice(0, 15));
                          }

                          setErrors((prev) => ({
                            ...prev,
                            mobile: false,
                          }));

                          setOtpMessage("");
                        }}
                        fullWidth
                        inputProps={{
                          maxLength: String(isdCode) === "91" ? 10 : 15,
                        }}
                        error={Boolean(errors.mobile)}
                      />

                      {errors.mobile && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{
                            display: "block",
                            mt: 0.25,
                            fontSize: "10px",
                          }}
                        >
                          {String(isdCode) === "91"
                            ? "Mobile number must be exactly 10 digits"
                            : "Please enter a valid mobile number"}
                        </Typography>
                      )}
                    </Box>

                    {/* SEND OTP BUTTON */}
                    <Button
                      variant="contained"
                      onClick={fetchOtp}
                      sx={{
                        mt: 2.35,
                        minWidth: 88,
                        height: 36,
                        px: 2,
                        borderRadius: "9px",
                        backgroundColor: "#dff5e5",
                        color: "#237A3B",
                        fontSize: "12px",
                        fontWeight: 700,
                        textTransform: "none",
                        boxShadow: "none",
                        flexShrink: 0,
                        "&:hover": {
                          backgroundColor: "#ccebd4",
                          boxShadow: "none",
                        },
                      }}
                    >
                      Send OTP
                    </Button>
                  </>
                )}

                {/* ================= EMAIL ================= */}
                {inputType === "email" && (
                  <>
                    <Box
                      sx={{
                        width: {
                          xs: "260px",
                          sm: "360px",
                          md: "450px",
                        },
                        maxWidth: "450px",
                        flexShrink: 0,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          mb: 0.6,
                          fontWeight: 600,
                          fontSize: "11px",
                          color: "#59636E",
                        }}
                      >
                        Email Address
                        <span
                          style={{
                            color: "#e53935",
                            marginLeft: "3px",
                          }}
                        >
                          *
                        </span>
                      </Typography>

                      <CustomTextFieldComp
                        size="small"
                        type="email"
                        placeholder="Enter email address"
                        InputProps={{
                          style: {
                            borderRadius: "9px",
                            fontSize: "12px",
                            backgroundColor: "#fafbfb",
                          },
                        }}
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);

                          setErrors((prev) => ({
                            ...prev,
                            email: false,
                          }));

                          setOtpMessage("");
                        }}
                        fullWidth
                        error={Boolean(errors.email)}
                      />

                      {errors.email && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{
                            display: "block",
                            mt: 0.25,
                            fontSize: "10px",
                          }}
                        >
                          Please enter a valid email address
                        </Typography>
                      )}
                    </Box>

                    {/* SEND OTP BUTTON */}
                    <Button
                      variant="contained"
                      onClick={fetchOtp}
                      sx={{
                        mt: 2.35,
                        minWidth: 88,
                        height: 36,
                        px: 2,
                        borderRadius: "9px",
                        backgroundColor: "#dff5e5",
                        color: "#237A3B",
                        fontSize: "12px",
                        fontWeight: 700,
                        textTransform: "none",
                        boxShadow: "none",
                        flexShrink: 0,
                        "&:hover": {
                          backgroundColor: "#ccebd4",
                          boxShadow: "none",
                        },
                      }}
                    >
                      Send OTP
                    </Button>
                  </>
                )}
              </Box>
            </Box>

            {/* ================= OTP RESULT ================= */}
            {isOtpFetched && (
              <Box
                sx={{
                  width: {
                    xs: "100%",
                    md: "190px",
                  },
                  minWidth: {
                    md: "190px",
                  },
                  minHeight: "72px",
                  px: 2,
                  py: 1.25,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "10px",
                  backgroundColor: otp ? "#f6fbf7" : "#fff8f8",
                  border: otp ? "1px solid #dceee0" : "1px solid #f3d0d0",
                  flexShrink: 0,
                }}
              >
                {otp ? (
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#8A9390",
                        mb: 0.2,
                        fontWeight: 600,
                        fontSize: "10px",
                      }}
                    >
                      OTP
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 800,
                        letterSpacing: "4px",
                        color: "#237A3B",
                        fontSize: "21px",
                        lineHeight: 1.2,
                      }}
                    >
                      {otp}
                    </Typography>

                    <Typography
                      variant="caption"
                      sx={{
                        color: "#8A9390",
                        display: "block",
                        mt: 0.35,
                        fontSize: "9px",
                      }}
                    >
                      Expires at {formatExpiry(otpWillExpire)}
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      color: "#d32f2f",
                      fontWeight: 600,
                      textAlign: "center",
                      fontSize: "11px",
                    }}
                  >
                    {otpMessage || "OTP not found"}
                  </Typography>
                )}
              </Box>
            )}
          </Box>

          <MainCard>
            <Box display="flex" justifyContent="space-between">
              <Box>
                <Typography variant="h3">Take Attendance</Typography>
              </Box>
              <Box>
                <IconButton onClick={toggleFilterSection}>
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Box>
            </Box>
            <Collapse in={isFilterOpen}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    size="small"
                    label="Please Select Date to Mark Attendance"
                    variant="outlined"
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        max: new Date().toISOString().split("T")[0],
                      },
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>

                {/* Other text fields */}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    size="small"
                    select
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Select Trainer"
                    variant="outlined"
                    value={selectedTrainer}
                    onChange={handleTrainerChange}
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" }, // Add borderRadius here
                    }}
                  >
                    {trainers.length > 0 ? (
                      trainers.map((trainer) => (
                        <MenuItem key={trainer.id} value={trainer.id}>
                          {trainer.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>
                        No Trainers Found.
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    size="small"
                    select
                    label="Select Class"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.target.value)}
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" }, // Add borderRadius here
                    }}
                  >
                    {classes.length > 0 ? (
                      classes.map((classItem) => (
                        <MenuItem key={classItem.id} value={classItem.id}>
                          {classItem.slot} - {classItem.test_type?.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>
                        No Classes Found. Please Select Trainer First.
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>

                {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomTextFieldComp
                    size="normal"
                    label="Delivery Mode"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={deliveryMode}
                    onChange={(e) => setDeliveryMode(e.target.value)}
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" }, // Add borderRadius here
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomTextFieldComp
                    size="normal"
                    label="Branch"
                    variant="outlined"
                    value={branch}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => setBranch(e.target.value)}
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" }, // Add borderRadius here
                    }}
                  />
                </Grid> */}
                {/* Filter button */}
              </Grid>
            </Collapse>
          </MainCard>
        </Grid>

        <Grid item xs={12}>
          {renderContent()}
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}

export default TakeAttendance;
